"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyInputWrapper = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var E2EPropertyWrapper_1 = require("../E2EPropertyWrapper");
var ErrorMessage_1 = require("../ErrorMessage");
var PropertyInputWrapper = function (_a) {
    var propertyId = _a.propertyId, propertyType = _a.propertyType, inputFormatType = _a.inputFormatType, errorMessages = _a.errorMessages, children = _a.children, className = _a.className, displayError = _a.displayError;
    return ((0, jsx_runtime_1.jsxs)(E2EPropertyWrapper_1.E2EPropertyWrapper, __assign({ propertyId: propertyId, propertyType: propertyType, inputFormatType: inputFormatType, className: className }, { children: [children, propertyType !== 'staticContent' && ((0, jsx_runtime_1.jsx)(ErrorMessage_1.FieldErrorMessages, { propertyId: propertyId, css: { marginTop: displayError ? '4px' : 0 }, displayError: displayError, errorMessages: errorMessages }))] })));
};
exports.PropertyInputWrapper = PropertyInputWrapper;
